import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const salesOrderDetailsTodo = createAsyncThunk('salesOrderDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `customer-sales-orders/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const salesOrderDetailsSlice = createSlice({
    name: 'salesOrderDetails',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(salesOrderDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(salesOrderDetailsTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default salesOrderDetailsSlice.reducer; 